import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import objectPath from 'object-path';
import Section from '../../section';
import Container from '../../container';
import Grid from '../../grid';
import LazyImg from '../../lazy-img';
import RenderMd from '../../render-md';
import StaggerIn from '../../stagger-in';
import TextWave from '../../text-wave';

const gridStyles = `
  max-width: 1060px;
  margin: auto;
  grid-row-gap: 36px;

  ${screen.above(bp.tablet, `
    grid-column-gap: 80px;
  `)};
`;

const gridItemStyles = `
  grid-column: span 6;

  ${screen.below(bp.tablet, `
    grid-column: span 12;
  `)};
`;

const AboutHelp = ({ blocks, id, title }) => {
  if (!blocks) return null;

  return (
    <Section id={id}>
      <Container>

        <TextWave>
          <SectionH2>{title}</SectionH2>
        </TextWave>

        <StaggerIn>
          <Grid styles={gridStyles}>

            {blocks.map((block) => {
              if (!block) return null;

              return (
                <Grid.Item styles={gridItemStyles} className="js-stagger" key={block.sys.id}>
                  <figure>

                    {objectPath.has(block, 'fields.blockPhoto.fields.file.url') &&
                      <LazyImg
                        width={465}
                        height={295}
                        src={`${block.fields.blockPhoto.fields.file.url}?w=465&h=295&fit=thumb&q=80&fm=jpg&fl=progressive`}
                        alt={block.fields.blockPhoto.fields.description}
                      />
                    }

                  </figure>
                  <Header>{block.fields.blockTitle}</Header>
                  <RenderMd source={block.fields.blockContent} />
                </Grid.Item>
              );
            })}

          </Grid>
        </StaggerIn>
      </Container>
    </Section>
  );
};

const Header = styled.h4`
  margin: 60px 0 30px;

  ${screen.below(bp.mobile, `
    margin: 40px 0 20px;
  `)};
`;

const SectionH2 = styled.h2`
  text-align: center;
  margin-bottom: 70px;

  ${screen.below(bp.tablet, `
    margin-bottom: 40px;
  `)};
`;

AboutHelp.propTypes = {
  blocks: PropTypes.array,
  id: PropTypes.string,
  title: PropTypes.string,
};

export default AboutHelp;
